import React from 'react';
import { NextSeo } from 'next-seo';
import { IntroductionSection } from '@/src/containers/ContactUs/components/IntroductionSection';
import { BookDemoSection } from '@/src/containers/ContactUs/components/BookDemoSection';
import { NeedHelp } from '@/src/containers/ContactUs/components/NeedHelp';
import { ContactForm } from '@/src/containers/ContactUs/components/ContactForm';
import { Header } from '@/src/containers/ContactUs/components/Header';
import PopupManager from '@/src/core/components/PopupManager';

import Footer from '@/src/containers/Landings/Footer';

const source = 'contact-us';

function ContactUS() {
  return (
    <>
      <NextSeo
        additionalLinkTags={[
          {
            href: 'https://fonts.googleapis.com/css2?family=Inter:wght@500&display=swap',
            rel: 'stylesheet',
          },
        ]}
      />
      <Header />
      <IntroductionSection />
      <BookDemoSection />
      <NeedHelp />
      <ContactForm />
      <Footer hasScrollToTop />
      <PopupManager />
    </>
  );
}

ContactUS.pageName = source;
ContactUS.withIntercomChatBot = true;
export default ContactUS;
